import { render, staticRenderFns } from "./currentYear.vue?vue&type=template&id=ae7c525c&scoped=true"
import script from "./currentYear.vue?vue&type=script&lang=js"
export * from "./currentYear.vue?vue&type=script&lang=js"
import style0 from "./currentYear.vue?vue&type=style&index=0&id=ae7c525c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7c525c",
  null
  
)

export default component.exports